<template>
  <div class="product-content">
    <defaultHeader :navIndex="0"></defaultHeader>
    <mobileHeader></mobileHeader>
    <boxTitle :titleIndex="1" :imgUrl="imgUrl" :imgTitle="imgTitle"></boxTitle>
    <div class="product">
      <div class="product-title">
        <div
          @click="clicklistNav(index)"
          class="product-title-item"
          v-for="(item, index) in secondNavList"
          :key="index"
        >
          <img :src="item.menuIcon" />
          <div :class="navIndex == index ? 'nav-active' : ''">{{ item.menuName }}</div>
        </div>
      </div>
      <div class="product-box">
        <div class="product-box-item" v-for="(item, index) in list" :key="index" @click="toDetail(item.id, index)">
          <img :src="item.articleImg" />
          <div>{{ item.articleTitle }}</div>
        </div>
      </div>
    </div>
    <template v-if="count">
      <mopaging :page-index="currentPage" :total="count" :page-size="pageSize" @change="pageChange"> </mopaging>
    </template>
    <defaulFooter></defaulFooter>
    <goBack></goBack>
  </div>
</template>

<script>
import {menuList, articleList, infoList} from '@/api/xx-index'
import defaultHeader from '../components/defaultheader.vue'
import mobileHeader from '../components/mobileheader.vue'
import defaulFooter from '../components/defaulfooter.vue'
import boxTitle from '../components/boxTitle.vue'
import mopaging from '@/components/mopaging'
import goBack from '@/components/goBack'
export default {
  components: {
    defaultHeader,
    defaulFooter,
    boxTitle,
    mobileHeader,
    mopaging,
    goBack
  },
  name: 'product',
  data() {
    return {
      navIndex: 0,
      count: 0,
      currentPage: 1,
      pageSize: 9,
      menuIds: '',
      secondNavList: [],
      secondMenuIds: '',
      listNav: [],
      list: [],
      sortId: '',
      imgUrl: '',
      imgTitle: ''
    }
  },
  created() {
    // window.location.href.split('=')[2]
    //公司基本信息数据
    infoList({deptId: 112}).then(res => {
      // console.log('公司基本信息', res)
      // console.log('asdasd', document.title)
      document.title = '精品案例-' + res.companyName + '-' + res.websiteDesc
    })
  },
  mounted() {
    //请求第一页数据
    // console.log('这是传过来的id', window.location.href.split('?')[1].substring(3, 5))
    if (this.$route.query.sortId != undefined) {
      this.menuIds = window.location.href.split('?')[1].substring(3, 5)
      this.navIndex = this.$route.query.index
      this.sortId = this.$route.query.sortId
      menuList({
        deptId: 112
      }).then(res => {
        // console.log('这是数据1', res)
        this.listNav = res
        for (let i = 0; i < this.listNav.length; i++) {
          if (Number(this.listNav[i].id) == Number(this.menuIds)) {
            this.secondNavList = this.listNav[i].childrenList
            this.imgTitle = this.listNav[i].menuBgimgTitle
            this.imgUrl = this.listNav[i].menuBgimg
          }
        }
      })
      this.getList(this.sortId)
    } else {
      // console.log('这是传过来的id', window.location.href.split('=')[1])
      this.menuIds = window.location.href.split('?')[1].substring(3, 5)
      menuList({
        deptId: 112
      }).then(res => {
        // console.log('这是数据2', res)
        this.listNav = res
        for (let i = 0; i < this.listNav.length; i++) {
          if (this.listNav[i].id == this.menuIds) {
            this.secondNavList = this.listNav[i].childrenList
            this.sortId = this.secondNavList[0].id
            this.imgTitle = this.listNav[i].menuBgimgTitle
            this.imgUrl = this.listNav[i].menuBgimg
          }
        }
        this.getList(this.secondNavList[0].id)
      })
    }
  },

  methods: {
    menuListx() {},

    clicklistNav(index) {
      this.navIndex = index
      this.sortId = this.secondNavList[index].id
      this.getList(this.secondNavList[index].id)
    },
    getList(id) {
      let param = {
        deptId: 112,
        menuIds: id,
        pageNum: this.currentPage,
        pageSize: 9
      }
      articleList(param).then(res => {
        // console.log('这是数据3', res)
        this.list = res.list
        this.count = res.total
      })
    },
    //产品详情
    toDetail(id, index) {
      this.$router.push({
        path: '/productDetails',
        query: {
          menuIds: this.sortId,
          id: id,
          indexFlag: index
        }
      })
    },
    pageChange(page) {
      this.currentPage = page
      //this.loadList();
      this.getList()
    }
  }
}
</script>

<style></style>
